/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderRefundResponsibility } from './OrderRefundResponsibility';
import {
    OrderRefundResponsibilityFromJSON,
    OrderRefundResponsibilityFromJSONTyped,
    OrderRefundResponsibilityToJSON,
    OrderRefundResponsibilityToJSONTyped,
} from './OrderRefundResponsibility';

/**
 * 
 * @export
 * @interface RefundAutoMenuOrderBody
 */
export interface RefundAutoMenuOrderBody {
    /**
     * 
     * @type {OrderRefundResponsibility}
     * @memberof RefundAutoMenuOrderBody
     */
    responsibility: OrderRefundResponsibility;
    /**
     * 
     * @type {string}
     * @memberof RefundAutoMenuOrderBody
     */
    errorMessage: string;
}



/**
 * Check if a given object implements the RefundAutoMenuOrderBody interface.
 */
export function instanceOfRefundAutoMenuOrderBody(value: object): value is RefundAutoMenuOrderBody {
    if (!('responsibility' in value) || value['responsibility'] === undefined) return false;
    if (!('errorMessage' in value) || value['errorMessage'] === undefined) return false;
    return true;
}

export function RefundAutoMenuOrderBodyFromJSON(json: any): RefundAutoMenuOrderBody {
    return RefundAutoMenuOrderBodyFromJSONTyped(json, false);
}

export function RefundAutoMenuOrderBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundAutoMenuOrderBody {
    if (json == null) {
        return json;
    }
    return {
        
        'responsibility': OrderRefundResponsibilityFromJSON(json['responsibility']),
        'errorMessage': json['errorMessage'],
    };
}

export function RefundAutoMenuOrderBodyToJSON(json: any): RefundAutoMenuOrderBody {
    return RefundAutoMenuOrderBodyToJSONTyped(json, false);
}

export function RefundAutoMenuOrderBodyToJSONTyped(value?: RefundAutoMenuOrderBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'responsibility': OrderRefundResponsibilityToJSON(value['responsibility']),
        'errorMessage': value['errorMessage'],
    };
}

